
    <div class="view-main" [style.height]="'100%'">
      <router-outlet></router-outlet>  
    </div>


// WEBPACK FOOTER //
// C:/Users/jjarvis/projects/pm-controls/test/app-component.ts.AppComponent.html